import { render, staticRenderFns } from "./vgpAvatar.vue?vue&type=template&id=da97ecc0&scoped=true&"
import script from "./vgpAvatar.vue?vue&type=script&lang=js&"
export * from "./vgpAvatar.vue?vue&type=script&lang=js&"
import style0 from "./vgpAvatar.vue?vue&type=style&index=0&id=da97ecc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da97ecc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da97ecc0')) {
      api.createRecord('da97ecc0', component.options)
    } else {
      api.reload('da97ecc0', component.options)
    }
    module.hot.accept("./vgpAvatar.vue?vue&type=template&id=da97ecc0&scoped=true&", function () {
      api.rerender('da97ecc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/avatar/vgpAvatar.vue"
export default component.exports